export function ImprintPage() {
  return (
    <>
      <h1>Imprint / Legal Disclosure</h1>

      <h2>Information according to § 5 TMG (German Telemedia Act):</h2>
      <p>
        spcfy GmbH
        <br />
        Niemeyerstraße 1<br />
        04179 Leipzig
        <br />
        Germany
      </p>

      <h2>Represented by:</h2>
      <p>
        Jérôme Morinière
        <br />
        (Additional managing directors may be listed in the commercial register)
      </p>

      <h2>Contact:</h2>
      <p>
        Phone: +49 341 33203174
        <br />
        Email: <a href="mailto:info@spcfy.io">info@spcfy.io</a>
        <br />
        Website:{' '}
        <a href="https://www.spcfy.io" target="_blank" rel="noopener noreferrer">
          www.spcfy.io
        </a>
      </p>

      <h2>Commercial Register Entry:</h2>
      <p>
        Registered at the Local Court (Amtsgericht) Leipzig
        <br />
        Commercial Register Number: HRB 37763
      </p>

      <h2>VAT Identification Number according to § 27a UStG:</h2>
      <p>DE327427196</p>

      <h2>Business Purpose:</h2>
      <p>
        Long-term archiving of bioinformatic DNA sequencing data, provision of software tools for reanalysis, visualization, and prediction
        using machine learning, including commercialization.
      </p>

      <h2>Content Responsibility according to § 55 (2) RStV:</h2>
      <p>
        Jérôme Morinière
        <br />
        (Address as above)
      </p>

      {/* The notice has to travel with the app a visitor loads, not only with the source: the repo is
          private and the bundler strips the per-icon comments in Util/icons/TaxaIcons.tsx. */}
      <h2>Image credits and third-party notices:</h2>
      <p>
        The bacteria, bug, fish and leaf glyphs are from{' '}
        <a href="https://fontawesome.com/" target="_blank" rel="noopener noreferrer">
          Font Awesome Free 5
        </a>
        , licensed under{' '}
        <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
          CC BY 4.0
        </a>
        . The icon geometry is used unchanged; only the surrounding SVG attributes differ, so that the glyphs inherit the
        surrounding text colour and size.
      </p>
      <p>
        The mushroom glyph is from{' '}
        <a href="https://github.com/tabler/tabler-icons" target="_blank" rel="noopener noreferrer">
          Tabler Icons
        </a>
        , MIT licensed, Copyright © 2020-2024 Paweł Kuna. The remaining interface icons are from{' '}
        <a href="https://heroicons.com/" target="_blank" rel="noopener noreferrer">
          heroicons
        </a>
        , MIT licensed, Copyright © Tailwind Labs, Inc.
      </p>
    </>
  )
}
